import { render, staticRenderFns } from "./TransactionsFilterGeoTransactions.vue?vue&type=template&id=485e6b60&"
import script from "./TransactionsFilterGeoTransactions.vue?vue&type=script&setup=true&lang=js&"
export * from "./TransactionsFilterGeoTransactions.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TransactionsFilterGeoTransactions.vue?vue&type=style&index=0&id=485e6b60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VIcon,VRow,VSwitch})
